<template>
  <div class="ed-dropdown-menu" v-bind:id="id" :class="{ 'ed-dropdown-menu--checkboxes' : hasCheckboxes, 'ed-dropdown-menu--light' : isColorLight }">
    <button class="ed-dropdown-menu__trigger" @click="dropdownMechanics(id)">{{ name }} <i class="ed-dropdown-menu__arrow icon-back-button-white"></i></button>
    <slot></slot>
  </div>

  <!-- TODO : Add real arrow picto -->

</template>

<script>

  export default {
    name: 'DropdownMenu',
    props: {
      name: String,
      id: String,
      isColorLight: Boolean,
      hasCheckboxes: Boolean,
    },
    methods: {
      dropdownMechanics(id) {
        const dropdownContent = document.getElementById(id);
        const allDropdown = document.getElementsByClassName('ed-dropdown-menu');
        if (dropdownContent.classList.contains('open')) {
          dropdownContent.classList.remove('open');
        } else {
          for (let i = 0; i < allDropdown.length; i += 1) {
            allDropdown[i].classList.remove('open');
          }
          dropdownContent.className += ' open';
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// dropdownMenu.vue?504423cc